
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
export const headerSlider = () => {
    new Swiper('.logotypes__container .swiper-container', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween:63,
        speed: 2000,
        breakpoints: {
            1200: {
                slidesPerView:6,
                spaceBetween:110
                
            }
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
    });
}